export class Country {
  countryId: number;
  countryName: string;
  isOFACSanctioned: boolean;
  isInternational: boolean;
  abbreviation: string;

  constructor(countryId: number,
              countryName: string,
              isOFACSanctioned: boolean,
              isInternational: boolean,
              abbreviation: string,) {
    this.countryId = countryId;
    this.countryName = countryName;
    this.isOFACSanctioned = isOFACSanctioned;
    this.isInternational = isInternational;
    this.abbreviation = abbreviation;
  }
}
